import React, { useState, useEffect } from "react";

const StudentPreview = ({ student }) => {
  const [photoURL, setPhotoURL] = useState(null);

  useEffect(() => {
    if (student && student.photo) {
      const url = URL.createObjectURL(student.photo);
      setPhotoURL(url);

      // Clean up the URL when the component unmounts
      return () => URL.revokeObjectURL(url);
    } else {
      setPhotoURL(null);
    }
  }, [student]);

  const getInitials = (firstName, lastName) => {
    return `${firstName?.[0] || ""}${lastName?.[0] || ""}`.toUpperCase();
  };

  const randomGradient = () => {
    const gradients = [
      "linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)",
      "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
      "linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%)",
      "linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%)",
    ];
    return gradients[Math.floor(Math.random() * gradients.length)];
  };

  return (
    <div className="student-preview box">
      <h2 className="main-heading">Student Details Preview</h2>
      <div className="profile-item">
        <div className="profile">
          {photoURL ? (
            <img src={photoURL} alt="Student Profile" />
          ) : (
            <div
              className="dummy-profile"
              style={{ background: randomGradient() }}
            >
              {getInitials(student.firstName, student.lastName)}
            </div>
          )}
        </div>
        <div className="student-details">
          <h3>
            {`${student.firstName || ""} ${student.middleName || ""} ${
              student.lastName || ""
            }`.trim() || "Student Name"}
          </h3>
          <p>
            <strong>ID:</strong> {student.studentId || "Not Generated"}
          </p>
        </div>
      </div>

      <div className="preview-group">
        <h4 className="sub-heading">Academic Information</h4>
        <div className="preview-item">
          <p>
            <strong>Class:</strong> {student.className || "Not Selected"}
          </p>
          <p>
            <strong>Date of Birth:</strong>{" "}
            {student.dateOfBirth || "Not Provided"}
          </p>
          <p>
            <strong>Gender:</strong> {student.gender || "Not Selected"}
          </p>
        </div>
      </div>

      <div className="preview-group">
        <h4 className="sub-heading">Contact Information</h4>
        <div className="preview-item">
          <p>
            <strong>Father's Name:</strong>{" "}
            {student.fathersName || "Not Provided"}
          </p>
          <p>
            <strong>Mother's Name:</strong>{" "}
            {student.mothersName || "Not Provided"}
          </p>
          <p>
            <strong>Phone:</strong> {student.phoneNumber || "Not Provided"}
          </p>
          <p>
            <strong>Alternative Phone:</strong>{" "}
            {student.alternativePhoneNumber || "Not Provided"}
          </p>
          <p>
            <strong>Email:</strong> {student.email || "Not Provided"}
          </p>
          <p>
            <strong>Address:</strong> {student.address || "Not Provided"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default StudentPreview;
